export const commercialPageConstants = {
    MENUUPDATE: 'MENUUPDATE'
}